import {Profile} from "crqlar-react-common/dist/models/profile/profile.model";
import {useTrackScreenVisit} from "crqlar-react-common/dist/utils/analytics.util";
import {Dialog} from "@mui/material";
import ProfileMatcher from "crqlar-react-common/dist/components/profilePreview/ProfileMatcher.component";

interface Props {
    open: boolean;
    onClose?: () => void;
    onChosenProfile: (profile: Profile | undefined) => void
}

const ReplaceProfileDialog = (props: Props) => {

    useTrackScreenVisit((props.open) ? 'replace profile dialog' : '')

    return (
        <Dialog
            open={props.open}
            onClose={() => {
                props.onClose?.()
            }}
            fullWidth
        >
            <ProfileMatcher
                onSelected={(chosenProfile) => {
                    props.onChosenProfile?.(chosenProfile)
                }}
            />

        </Dialog>
    )
}

export default ReplaceProfileDialog
